var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 26.8889V6.97778C2 5.2354 2 4.3642 2.34256 3.6987C2.64386 3.1133 3.12466 2.63736 3.71603 2.3391C4.38832 2 5.26841 2 7.02857 2H18.9714C20.7316 2 21.6117 2 22.284 2.3391C22.8753 2.63736 23.3562 3.1133 23.6574 3.6987C24 4.3642 24 5.2354 24 6.97778V23.7778H5.14286C3.4071 23.7778 2 25.1706 2 26.8889ZM2 26.8889C2 28.6072 3.4071 30 5.14286 30H24M22.4286 23.7778V30M17.7143 18.3333C17.2686 16.5583 15.3273 15.2222 13 15.2222C10.6727 15.2222 8.73143 16.5583 8.28571 18.3333M13 9H13.0157M14.5714 9C14.5714 9.8591 13.8679 10.5556 13 10.5556C12.1321 10.5556 11.4286 9.8591 11.4286 9C11.4286 8.1409 12.1321 7.44444 13 7.44444C13.8679 7.44444 14.5714 8.1409 14.5714 9Z",
    stroke: "#1E4387",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactGroup);
export default __webpack_public_path__ + "static/media/contact-group.f1c8e6c0361e9c5f031987cd1bd974df.svg";
export { ForwardRef as ReactComponent };